import { type AttachmentResponseDto } from '@issuemanager/api-client';
import { FileList, ViewLabelValue } from '@issuemanager/apps/client/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  regularAttachments: AttachmentResponseDto[];
  approvalAttachments: AttachmentResponseDto[];
  spacing?: number;
};

export function GroupedDocumentList({
  regularAttachments,
  approvalAttachments,
  spacing,
}: Props): React.JSX.Element {
  const { t } = useTranslation('issue');

  return (
    <>
      {Boolean(regularAttachments.length) && (
        <ViewLabelValue
          label={t('form.labels.attachments')}
          value={<FileList files={regularAttachments} showVerticalDividers />}
          testId='attachments'
          spacing={spacing}
        />
      )}
      {Boolean(approvalAttachments.length) && (
        <ViewLabelValue
          label={t('form.labels.approvalAttachments')}
          value={<FileList files={approvalAttachments} showVerticalDividers />}
          testId='approvalAttachments'
          spacing={spacing}
        />
      )}
    </>
  );
}
